import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, ClickAwayListener, Divider } from '@mui/material';

import { ReactComponent as AccountIcon } from 'assets/icons/AccountIcon.svg';
import { ReactComponent as DropdownArrow } from 'assets/icons/DropdownArrow.svg';

import { useToggle } from 'hooks/useToggler';

import { IAccountSettingItem } from 'interfaces/account';

import { Button } from 'components/_basic/Button/Button';

import { accountSettingsStyles } from './AccountSettings.styles';
import { useAccountSettingsData } from './hooks/useAccountSettingsData';

export const AccountSettings: FC = () => {
  const { t } = useTranslation();

  const [isAccountMenuShown, setIsAccountMenuShown] = useToggle(false);

  const handleCloseClick = () => setIsAccountMenuShown(false);

  const { menuContent } = useAccountSettingsData();

  return (
    <>
      <Button
        fullWidth
        sx={accountSettingsStyles.accountButton}
        startIcon={<AccountIcon />}
        endIcon={<DropdownArrow />}
        onClick={setIsAccountMenuShown}
      >
        {t('accountButton')}
      </Button>
      {isAccountMenuShown && (
        <ClickAwayListener onClickAway={handleCloseClick}>
          <Box component="ul" sx={accountSettingsStyles.accountMenu} onClick={handleCloseClick}>
            {menuContent.map(
              ({ title, clickHandler, icon }: IAccountSettingItem, index: number, itemsArr: IAccountSettingItem[]) => (
                <Fragment key={title}>
                  {index === itemsArr.length - 1 && <Divider />}
                  <Box component="li" sx={accountSettingsStyles.accountMenuItem}>
                    <Button
                      fullWidth
                      onClick={clickHandler}
                      endIcon={icon}
                      sx={accountSettingsStyles.accountMenuButton}
                    >
                      {title}
                    </Button>
                  </Box>
                </Fragment>
              ),
            )}
          </Box>
        </ClickAwayListener>
      )}
    </>
  );
};
